'use strict';
/**
 * Created by Qui Huynh on 07/11/2017.
 */
angular
    .module('app.userManagement')
    .controller('changePasswordWarningModalCtrl', [
        '$state',
        '$scope',
        '$rootScope',
        '$modalInstance',
        '$modal',
        function ($state, $scope, $rootScope, $modalInstance, $modal) {
            var me = this;

            var closeModal = function() {
                $modalInstance.close();
            };

            var goToChangePwd = function () {
                closeModal();
                $state.go('home.profileChangePassword');
            };

            (function init() {
                me.closeModal = closeModal;
                me.goToChangePwd = goToChangePwd;
            })();
        }
]);